import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantAttestStats = (token, id) => {
    return fetch(`${apiUrl}tenant_attest_stats/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantAttestStats
